import { render } from "./PodcastIcon.vue?vue&type=template&id=f77de304&scoped=true"
import script from "./PodcastIcon.vue?vue&type=script&lang=js"
export * from "./PodcastIcon.vue?vue&type=script&lang=js"

import "./PodcastIcon.vue?vue&type=style&index=0&id=f77de304&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2677690992/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f77de304"]])

export default __exports__